import React, {useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import ScrollToTop from "./components/layout/scrolltotop.jsx";

import Home from './pages/home.jsx';
import StockTanks from './pages/stocktanks.jsx';
import Tankkd from './pages/tankkd.jsx';
import Accessoires from './pages/accessoires.jsx';
import ProductPage from "./pages/productpage.jsx";
import AccessoriesPage from './pages/accessoriepage.jsx';
import Devis from './pages/devis.jsx';
import FAQ from './pages/faq.jsx';
import CGU from  './pages/cgu.jsx';
import Confidentialite from './pages/confidentialite.jsx';
import MentionsLegales from './pages/mentions-legales.jsx';

import Navbar from './components/layout/navbar.jsx';
import Footer from './components/layout/footer.jsx';
import Loading from './components/layout/loading.jsx';
import InfosBar from './components/layout/infosbar.jsx';

function App() {
  const [isLoading, setIsLoading] = useState(true); 
  const location = useLocation(); 

  useEffect(() => {
      const timer = setTimeout(() => {
          setIsLoading(false); 
      }, 1500);

      return () => clearTimeout(timer); 
  }, []);

  useEffect(() => {
    const scrollToHashSection = () => {
      const hash = window.location.hash;
      if (hash) {
        const targetElement = document.getElementById(hash.substring(1));
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }
    };

    scrollToHashSection();
  }, [location]); 

  if (isLoading) {
    return (
        <Loading />
    );
  }

  return (
    <div>
      
      <InfosBar />
      <Navbar />
        <ScrollToTop />
   

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/stocktanks" element={<StockTanks />} />
        <Route path="/tankkd" element={<Tankkd />} />
        <Route path="/accessoires" element={<Accessoires />} />
        <Route path="/devis" element={<Devis />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/cgu" element={<CGU />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/confidentialite" element={<Confidentialite />} />
        <Route path="/produit/:name" element={<ProductPage />} />
        <Route path="/accessoire/:name" element={<AccessoriesPage />} />
      </Routes>

      <Footer />
    </div>
  );
}

function AppWrapper() {
  return (
        <Router>
          <App />
        </Router>
  );
}

export default AppWrapper;
